<template>
    <div :class="'social-form-wrapper ' + data.type">
        <SocialNormal
                v-if="data.type == 'normal'"
                v-model="value"
                v-on:next-step="$emit('next-step')"
                v-on:go-back="$emit('go-back')"
                v-on:cancel-step="$emit('cancel-step')"
                :data="data"
                :value="value"
                :index="index" />
        <SocialInstagram
                v-if="data.type == 'instagram'"
                v-model="value"
                v-on:next-step="$emit('next-step')"
                v-on:go-back="$emit('go-back')"
                v-on:cancel-step="$emit('cancel-step')"
                :data="data"
                :value="value"
                :user="user"
                :index="index" />
        <SocialTikTok
                v-if="data.type == 'tiktok'"
                v-model="value"
                v-on:next-step="$emit('next-step')"
                v-on:go-back="$emit('go-back')"
                v-on:cancel-step="$emit('cancel-step')"
                :data="data"
                :value="value"
                :user="user"
                :index="index" />
    </div>
</template>

<script>
    import InputGroup from "./InputGroup";
    import IconTextCheckbox from "./IconTextCheckbox";
    import IconTextInputCheckbox from "./IconTextInputCheckbox";
    import FormError from "./FormError";
    import SocialNormal from "../Social/SocialNormal";
    import SocialInstagram from "../Social/SocialInstagram";
    import SocialTikTok from "../Social/SocialTikTok";

    export default {
        name: "SocialForm",
        components: {
            SocialTikTok,
            SocialInstagram, SocialNormal, FormError, IconTextInputCheckbox, IconTextCheckbox, InputGroup},
        props: ["data", "value", "index", "user"]
    }
</script>

<style lang="scss">

</style>